import { render, staticRenderFns } from "./MainSelect.vue?vue&type=template&id=396ca906"
import script from "./MainSelect.vue?vue&type=script&lang=js"
export * from "./MainSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports